export default __webpack_public_path__ + "static/media/thescorpioncaveunchained.029c6290.jpg";